import { FC, useState } from 'react';
import { selectedDiagnosticReportsFilter } from '../../redux/reducers/filterDiagnosticReport';
import { PreloadedQuery } from 'react-relay';

import { DiagnosticsCompletedStudentsQuery } from '../../graphQLOperations/__generated__/DiagnosticsCompletedStudentsQuery.graphql';
import { RowData, SkillPerformanceByClassTable } from './SkillPerformanceByClassTable';
import { Button } from 'primereact/button';
import { DiagnosticReportCards } from './DiagnosticReportCards';
import { exportDiagnosticSkillsCsv } from '../../businessLogicService/downloadDiagnosticSkillsCsv';

interface Props {
  completedQueryRef: PreloadedQuery<DiagnosticsCompletedStudentsQuery, Record<string, unknown>> | null | undefined;
  notCompletedQueryRef: PreloadedQuery<DiagnosticsCompletedStudentsQuery, Record<string, unknown>> | null | undefined;
  reportFilters: ReturnType<typeof selectedDiagnosticReportsFilter>;
}

export const SkillPerformanceByClass: FC<Props> = ({ completedQueryRef, notCompletedQueryRef, reportFilters }) => {
  const [exportRows, setExportRows] = useState<RowData[]>([]);

  const handleExport = () => {
    if (!exportRows.length) return;
    exportDiagnosticSkillsCsv(exportRows);
  };
  return (
    <div>
      <div className="nc_block w-full">
        <div className="surface-0 p-4 border-round-xl">
          <div className="md:flex justify-content-between">
            <h1>Report for class {reportFilters?.classes[0]?.name}</h1>
            <Button
              onClick={handleExport}
              label="Download Class Level Report"
              icon="nc_icon-nc_export icon-sm"
              outlined
              iconPos="right"
              disabled={exportRows.length === 0}
            />
          </div>
          <div className="mt-5">
            {completedQueryRef && notCompletedQueryRef && (
              <DiagnosticReportCards
                completedQueryRef={completedQueryRef}
                notCompletedQueryRef={notCompletedQueryRef}
              />
            )}
          </div>
          <div className="mt-5">
            <SkillPerformanceByClassTable reportFilters={reportFilters} onTableData={setExportRows} />
          </div>
        </div>
      </div>
    </div>
  );
};
